import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GuardContext {
  context?: {
    doContinuation: boolean;
    message?: string;
  };
}
